import { Component } from 'react';
import { forEachObjIndexed, uniq, keys, isNil } from 'ramda';
import { PoiName, PoiTabBar, DisplayEditor, InternalEditor, PoiSave, InfoEditor, ImageEditor, TagEditor, JsonEditor } from '../../components';
import s from '../../components/poi-sheet/PoiSheet.module.scss';

import entities from './data/cached-sea-pois.json';

const POI = entities['66'];

export default class PoiSheetEditor extends Component {
    constructor(props) {
        super(props);
        this.state = { originalPoi: POI, changes: {}, selectedTabId: 'tags' };
        window.componentUnderTest = this;
    }

    onEdit = newChanges => {
        this.setState(state => {
            const { originalPoi } = this.state;
            const revisedChanges = { ...state.changes, ...newChanges };
            forEachObjIndexed((value, key) => {
                const originalValue = originalPoi[key];
                if (value === originalValue) {
                    delete revisedChanges[key];
                }
            }, revisedChanges);
            return { changes: revisedChanges };
        });
    };

    onRevertChanges = () => {
        this.setState({ changes: {} });
    };

    onSave = () => {
        const { originalPoi, changes } = this.state;
        const poiInProgress = { ...originalPoi, ...changes };
        this.setState({ originalPoi: poiInProgress, changes: {} });
    };

    onSelectTab = selectedTabId => {
        this.setState({ selectedTabId });
    };

    selectEditor = tab => {
        switch (tab) {
            case 'display':
                return DisplayEditor;
            case 'info':
                return InfoEditor;
            case 'images':
                return ImageEditor;
            case 'tags':
                return TagEditor;
            case 'internal':
                return InternalEditor;
            case 'json':
                return JsonEditor;
            default:
                return InfoEditor;
        }
    };

    createPoiStatusOption = poiStatus =>
        poiStatus === 'archived'
            ? { label: 'Restore POI', onSelect: () => console.log('user clicked "restore"'), icon: 'icon-poi-restore' }
            : { label: 'Remove POI', onSelect: () => console.log('user clicked "remove"'), icon: 'icon-trash' };

    createIconMenuOptions = (isV5, poiStatus, onDuplicatePoi) => {
        const poiStatusOption = this.createPoiStatusOption(poiStatus);
        return isV5 ? [poiStatusOption] : [poiStatusOption, { label: 'Duplicate POI', onSelect: onDuplicatePoi, icon: 'icon-duplicate-POI' }];
    };

    render() {
        const { originalPoi, changes, selectedTabId } = this.state;
        const poiInProgress = { ...originalPoi, ...changes };
        const allTags = uniq(['foo', 'bar', 'bat', 'banana', 'petunia', ...poiInProgress.displayTags, ...poiInProgress.tags]).map(tag => ({ value: tag, label: tag }));
        const category = { canonicalName: 'eat', value: 'eat', label: 'eat', v4Icons: ['eat', 'vending'] };
        const categories = [category];
        const v4Icon = changes && changes.icon ? changes.icon : originalPoi.icon;
        const Editor = this.selectEditor(selectedTabId);
        const changedFields = keys(changes);
        const poiStatus = 'current';

        const iconMenuOptions = this.createIconMenuOptions(true, poiStatus, this.onDuplicatePoi);

        return (
            <div className={s.editor}>
                <div className={s.poiSheet} data-testid={'Nick here'}>
                    <PoiName isV5 isDisabled={false} poi={poiInProgress} poiStatus={poiStatus} iconMenuOptions={iconMenuOptions} />

                    <PoiTabBar onSelectTab={this.onSelectTab} selectedTabId={selectedTabId} changedFields={changedFields} />

                    <div className={s.editorWrapper}>
                        <Editor
                            allTags={allTags}
                            changedFields={changedFields}
                            categories={categories}
                            category={category}
                            disabled={false}
                            displayTags={poiInProgress.displayTags ? uniq(poiInProgress.displayTags) : []}
                            images={poiInProgress.images}
                            isV5={false}
                            logo={isNil(poiInProgress.logo) ? [] : [poiInProgress.logo]}
                            onUpdatePoiField={this.onEdit}
                            onUpdatePoiFields={this.onEdit}
                            openImageInNewTab={this.openImageInNewTab}
                            poi={poiInProgress}
                            tags={poiInProgress.tags ? uniq(poiInProgress.tags) : []}
                            terminals={['Terminal 1', 'Terminal 2']}
                            v4Icon={v4Icon}
                        />
                    </div>

                    <PoiSave onSave={this.onSavePoi} poi={poiInProgress} changedFields={changedFields} onClose={this.onRevertChanges} />
                </div>
            </div>
        );
    }
}
